import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { SharedModule } from '@app/core/shared/shared.module';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      title:
        'Kingpin Sports Picks: Experts get Ranked, you follow their Picks',
      meta: [
        {
          name: 'description',
          description: 'We rank the top experts, you follow their Sports Picks',
        },
      ],
    },
  },
  { path: '', redirectTo: '', pathMatch: 'full' }, // redirect to `first-component`
];

@NgModule({
  declarations: [HomeComponent],
  imports: [CommonModule, RouterModule.forChild(routes), SharedModule],
})
export class HomeModule {}
